<script>
  import ImageMasonry from '../../../src/svelte/ImageMasonry.svelte';
  import images from '../images';
</script>

<ImageMasonry images={images} />
